import * as React from 'react';
export const Svg = ({ svg, title, }) => {
    // Depending on the bundler the "Svg" loaded will be either a string, and element to be constructed or a rendered element
    // Wrapping in this sort of construc
    const SvgElement = svg;
    return (React.createElement(React.Fragment, null,
        typeof SvgElement === 'string' && (React.createElement("img", { alt: title || '', src: SvgElement })),
        typeof SvgElement === 'function' && (React.createElement(SvgElement, { title: title || '' })),
        typeof SvgElement === 'object' && SvgElement));
};
export default Svg;
